import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'har-ejeren-anmeldt-skaden';
        case 'har-ejeren-anmeldt-skaden':
            return 'om-ejeren';
        case 'om-ejeren':
            return 'dato';
        case 'dato':
            return 'adresse';
        case 'adresse':
            return 'beskriv-skaden';
        case 'beskriv-skaden':
            return 'hvad-er-skadet';
        case 'hvad-er-skadet':
            return 'laant-eller-lejet';
        case 'laant-eller-lejet':
            return 'om-koeretoej';
        case 'om-koeretoej':
            if (
                getValueOrDefault(formConfig, formValues, 'erskadenbegetmedetkretjellerenmotoriseretgenstand').value ===
                'Ja'
            ) {
                return 'om-koeretoej-eller-genstand';
            }

            if (
                getValueOrDefault(formConfig, formValues, 'erskadenbegetmedetkretjellerenmotoriseretgenstand').value ===
                'Andet'
            ) {
                return 'beskriv-koeretoej-eller-genstand';
            }
            return 'om-ansvar';
        case 'om-koeretoej-eller-genstand':
            return 'om-ansvar';
        case 'beskriv-koeretoej-eller-genstand':
            return 'om-ansvar';
        case 'om-ansvar':
            return 'politianmeldelse';
        case 'politianmeldelse':
            return 'dokumentation';
        case 'dokumentation':
            return 'virksomhedsoplysninger';
        case 'virksomhedsoplysninger':
            return 'forsikringsmaegler';
        case 'forsikringsmaegler':
            return 'om-virksomheden';
        case 'om-virksomheden':
            return 'andet-selskab';
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            } else {
                return 'om-dig';
            }
        case 'hvilket-selskab':
            return 'om-dig';
        case 'om-dig':
            return 'resume';
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
